import React from 'react';
export function PlusIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.983 11.027l-5-.007.007-5a1 1 0 00-2 0l-.007 5-5-.008a1 1 0 000 2l5 .008-.008 5a1 1 0 102 0l.008-5 5 .007a1 1 0 100-2z"
  }));
}